<template>
    <div class="page">
        <div class="page-list">
            <template v-for="item in result.list">
                <div class="page-flex" @click="changeState(item)" :class="{ 'label-defined-active': autoPkgId == item.id }"
                    :key="item.id">
                    <div class="title">{{ item.packageName ? item.packageName : item.name }}</div>
                    <div class="content">
                        <div class="left">套餐到期可自动续费 </div>
                        <div class="right">
                            <!-- <template v-if="result.subJuan && (result.subJuan.price || result.subJuan.vipSubPrice)">
                                <p v-if="item.showPrice && item.showPrice > 0">￥<span>{{ item.showPrice }}</span></p>

                                <p v-else>￥<span>{{ (item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100) -
                                    (result.subJuan.price ? result.subJuan.price * 1 : 0) - (result.subJuan.vipSubPrice ?
                                        result.subJuan.vipSubPrice * 1 : 0) > 0 ?
                                    ((item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100) -
                                        (result.subJuan.price ? result.subJuan.price * 1 : 0) - (result.subJuan.vipSubPrice ?
                                            result.subJuan.vipSubPrice * 1 : 0)).toFixed(2) : 0 }}</span></p>

                                <div class="fdaw">原价{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</div>
                            </template>
                            <template v-else>
                                <p>￥<span>{{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}</span></p>
                            </template> -->
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="renewal">
            <div class="renewal-flex">
                <div class="renewal-flex-left">
                    <div class="renewal-flex-left-top-flex">
                        <div class="renewal-flex-left-top-flex-item1">
                            <img src="@/assets/323.png" alt="">
                        </div>
                        <div class="renewal-flex-left-top-flex-item2">开启自动续费</div>
                        <div class="renewal-flex-left-top-flex-item3">
                            <img src="@/assets/325.png" alt="">
                        </div>
                    </div>
                    <div class="renewal-flex-left-content">流量到期自动订购基础包</div>
                </div>
                <div class="renewal-flex-right">
                    <van-checkbox v-model="checked" @change="updateIsAutoState">
                        <template #icon="props">
                            <img class="img-icon"
                                :src="props.checked ? require('@/assets/326.png') : require('@/assets/324.png')">
                        </template>
                    </van-checkbox>
                </div>
            </div>
        </div>
        <van-dialog v-model="show" title="余额密码" show-cancel-button @cancel="cancel" @confirm="confirm">
            <van-password-input :value="value" :length="6" :focused="showKeyboard" @focus="showKeyboard = true" />
        </van-dialog>
        <!-- <van-dialog v-model="showKeyboard"  :overlay="false" :position="bottom">
            <van-number-keyboard
                v-model="value"
                :show="showKeyboard"
                @blur="showKeyboard = false"
            />
        </van-dialog> -->
        <van-number-keyboard id="keyboardDefined" v-model="value" :z-index="2015" @delete="onDelete" @input="onInput"
            :maxlength="6" :show="showKeyboard" @blur="showKeyboard = false" />
        <div class="istine" v-if="!istine"><van-icon name="warning" /> 当前未绑定续费套餐</div>
        <van-button type="info" size="normal" block round @click="sumbitType">提交</van-button>

        <div class="balanceRecharge-tip">
            <p><span>温馨提醒</span></p>
            <p>1，套餐到期前5天，自动使用余额续费</p>

            <p>2，请确保卡的余额充足，避免套餐续费失败</p>

        </div>


    </div>
</template>
<script>
import { wxRequest } from '@/api/user.js'
import { Dialog } from 'vant'
export default {
    data() {
        return {
            checked: false, // 0 开启  1关闭
            showKeyboard: false,
            value: '',
            autoPkgId: "",
            result: [],
            istine: false,
            show: false
        }
    },
    mounted() {
        this.selectIsAutoState()
        this.init()
    },
    methods: {
        //列表数据初始化
        init() {
            var data = {
                firstPkg: "1T",
                iccid: this.$store.state.iccid
            }
            wxRequest('sim/user/soldPkg', data, 'get').then(res => {
                this.result = res.data.data
                if (res.data.code === '200' && this.result.list.length > 0) {
                    this.autoPkgId = this.result.list.find(item => item.autoPkg === 1) ? this.result.list.find(item => item.autoPkg === 1).id : ''
                    this.istine = this.result.list.filter(item => item.autoPkg === 1).length > 0
                }
            })
        },
        //更新自动续费
        updateIsAutoState() {
            const param = {
                iccid: this.$store.state.iccid,
                isAuto: this.checked ? 0 : 1
            }
            wxRequest('sysUser/account/update/isAuto/state', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.selectIsAutoState()
                } else if (res.data.code === '404') {
                    Dialog.confirm({
                        title: "提示",
                        message:
                            "当前卡尚未充值余额，请点击 确定 前往充值余额后，再来续订套餐！",
                    }).then(() => {
                        this.$router.replace('/newUser/recharge')
                    })
                        .catch(() => { });
                } else {
                    Dialog.alert({ title: '修改提示', message: res.data.message })
                }
            })
        },
        selectIsAutoState() {
            const param = {
                iccid: this.$store.state.iccid
            }
            wxRequest('sysUser/account/select/isAuto/state', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.checked = res.data.data === 0
                }
            })
        },
        onDelete() {
            this.value = this.value.slice(0, this.value.length - 1);
        },
        onInput(e) {
            console.log(e)
        },
        //显示密码输入框
        sumbitType() {
            if (!this.autoPkgId) {
                Dialog.alert({ title: '提示', message: '请先选择套餐' })
                return
            }
            this.show = true
            this.showKeyboard = true
        },
        cancel() {
            this.value = ''
            this.show = false
        },
        confirm() {
            var params = {
                iccid: this.$store.state.iccid,
                payPass: this.value,
                autoPkg: this.autoPkgId
            }
            wxRequest('sim/update/auto/pkg', params, 'post').then(res => {
                if (res.data.code === '200') {
                    this.init()
                    Dialog.alert({ title: '提示', message: res.data.message })
                } else {
                    Dialog.alert({ title: '提示', message: res.data.message })
                }
            })
        },
        //选择数据
        changeState(data) {
            this.autoPkgId = data.id
        }
    }
}
</script>
<style scoped lang="less">
.page {
    height: 100%;
    background: #f5f5f5;

    .balanceRecharge-tip {
        padding: 10px 20px 10px 20px;

        p {
            span {
                color: #FFA941;
            }

            line-height: 20px;
        }
    }

    .page-list {
        width: 94%;
        margin: 0 auto;
        border-radius: 11px;
        padding-top: 10px;

        .page-flex {
            background: #fff;
            padding: 14px;
            border: 1px solid #dbdbdb;
            border-radius: 11px;
            margin-bottom: 10px;

            .title {
                margin: 5px 0;
                color: #28292D;
                font-weight: bold;
                font-size: 18px;
            }

            .content {
                display: flex;

                .left {
                    margin: 10px 0;
                    font-weight: 500;
                    color: #63666D;
                    width: 80%;
                    line-height: 17px;
                    font-size: 12px;
                }

                .right {
                    font-size: 14px;
                    font-weight: bold;
                    color: #397EF5;

                    span {
                        font-size: 24px;
                        color: #397EF5;
                    }
                }
            }
        }

        .label-defined-active {
            background: #EFF5FF;
            border: 1px solid #397EF5;
        }
    }

    .renewal {
        width: 94%;
        background: #fff;
        border-radius: 8px;
        margin: 20px auto;

        .renewal-flex {
            display: flex;
            align-items: center;
            padding: 14px 16px;
            justify-content: space-between;

            .renewal-flex-left-top-flex {
                display: flex;

                .renewal-flex-left-top-flex-item1,
                .renewal-flex-left-top-flex-item3 {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;

                    img {
                        width: 100%;
                    }
                }

                .renewal-flex-left-top-flex-item2 {
                    color: #28292D;
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    margin-right: 4px;
                }
            }

            .renewal-flex-left-content {
                color: #63666D;
                font-size: 12px;
                font-weight: 400;
                margin-top: 10px;
            }

            .renewal-flex-right {
                width: 20px;
                height: 20px;

                .van-checkbox {
                    overflow: auto;

                    ::v-deep.van-checkbox__icon {
                        width: 100%;
                        height: 100%;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }

    .van-button {
        width: 90%;
        margin: 14px auto;
    }

    .van-dialog__content {
        margin: 10px 0;
    }

    .istine {
        width: 90%;
        margin: 0 auto;
        font-size: 14px;
        color: red;
    }
}

::v-deep .van-dialog__content {
    padding: 10px 0;
}</style>